import { toast } from "react-toastify";
import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const getSubscriptions = async (data) => {
  try {
    const res = await baseAPI.get(`/get-subscription-plan`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const upgradeUserSubscription = async (data) => {
  try {
    
    const formdata = new FormData();
    formdata.append("payment_responce", JSON.stringify(data?.payment_responce));
    formdata.append("subscription_id", data?.subscription_id);

    const res = await baseAPI.post(`/upgrad-subscription-plan`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    toast.error("Subscription upgrade failed.");
    console.log(error);
  }
};

const getUserSubscriptionHistory = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("page", data.page);
    formdata.append("search", data.search);

    const res = await baseAPI.post(`/subscription-history`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const initiatePaymentByAPI = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("amount", data.amount);
    formdata.append("redirect", data.redirect);

    const res = await baseAPI.post(`/pay-subscription-plan`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const checkPaymentStatus = async (tap_id) => {
  try {
    const formdata = new FormData();
    formdata.append("tap_id",tap_id);

    const res = await baseAPI.post(`/check-payment`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};



const SubscriptionService = {
  getSubscriptions,
  upgradeUserSubscription,
  getUserSubscriptionHistory,
  initiatePaymentByAPI,
  checkPaymentStatus
};

export default SubscriptionService;
